/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Ovid_DetailInputs */



/**
* | output |
* | --- |
* | "Inspections under OCIMF's Offshore Vessel Inspection Database (OVID) for offshore support vessels such as platform supply and anchor-handling vessels. The in..." |
*
* @param {Service_Ovid_DetailInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const service_ovid_detail = /** @type {((inputs?: Service_Ovid_DetailInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Ovid_DetailInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("依据 OCIMF 海上船舶检查数据库（OVID）对平台供应船、起抛锚船等海工支持船开展的检查。检查对照 OVID 问卷评估船舶，并上传报告供租家审阅。")
	return /** @type {LocalizedString} */ ("Inspections under OCIMF's Offshore Vessel Inspection Database (OVID) for offshore support vessels such as platform supply and anchor-handling vessels. The inspection assesses the vessel against the OVID questionnaire and uploads the report for charterers to review.")
});